<template>
  <v-app>
    <router-view />
    <AlertSystem />
  </v-app>
</template>

<script setup>
import AlertSystem from '@/components/AlertSystem.vue'
</script>